$(document).ready(function () {
  $("#callbackModal").on("shown.bs.modal", function () {
    $("#callbackModal .modal-body").html(
      '<iframe width="100%" height="420" frameborder="0" scrolling="no" src="https://c2c.avanser.com/ajax/form.php?code=SCigPjfM684wyO9GDT9x" id="callbackmodal_frame"></iframe>'
    );
    $.get("<?php echo URLPATH; ?>homepage/serviceonline/", "", function (data) {
      if (data != "1") {
        $("#callbackModal .modal-body").css("display", "inline");
        $("#callbackModal .modal-body").html(
          '<h3>sorry <span style="color:green">mate</span>, our phone support team are unavailable right now</h3><p>please try again during phone support operating hours (8.30am - 7.00pm monday - saturday) or drop an email to <a href="mailto:support@letsbemates.com.au">support@letsbemates.com.au</a></p>'
        );
        $("#li_card_we_call_you").css("display", "none");
      }
    });
  });

  if ($("#btn-signup-menu").length > 0) {
    $(document).click(function () {
      if ($("#btn-signup-menu").hasClass("active")) {
        $("#btn-signup-menu").removeClass("active");
        $(".signup-child").slideUp();
      }
    });

    $("#btn-signup-menu").on("click", function (e) {
      e.preventDefault();
      if ($(this).hasClass("active")) {
        $(this).removeClass("active");
        $(".signup-child").slideUp();
      } else {
        $(this).addClass("active");
        $(".signup-child").slideDown();
      }
    });
  }

  if ($("#btn-signup-menu-m").length > 0) {
    $("#btn-signup-menu-m").on("click", function (e) {
      e.preventDefault();
      if ($(this).hasClass("activex")) {
        $(this).removeClass("activex");
        $(".signup-child-m").slideUp();
      } else {
        $(this).addClass("activex");
        $(".signup-child-m").slideDown();
      }
    });
  }
});
